import { sanityFetch } from "@natklok/util/sanity";
import groq from "groq";
import { useQuery } from "@tanstack/react-query";
import transformSanityTeacherQuizModule, {
  SanityTeacherQuizModule,
} from "@natklok/sanity/transform/teacherQuizModule";

const query = groq`*[_type=="teacherQuizModule"]{
  _id,
  _type,
  introSlideTitle,
  introSlideDescription,
  youtubeVideoId,
  isExtraMaterial,
  quizModule->{
    title,
    desc,
    slides[]->{
      _id
    }
  },
  discussionSlides[]->{
    _id,
    title,
    description,
    allowComments,
    statConfig
  }
}`;

function getTeacherQuizModules() {
  return sanityFetch<SanityTeacherQuizModule[]>({ query }).then((modules) => {
    console.log(modules);
    const transformedModules = modules.map(transformSanityTeacherQuizModule);
    console.log(transformedModules);
    return transformedModules;
  });
}

export function useTeacherQuizModules() {
  console.log("useTeacherQuizModules");
  const { isLoading, error, data } = useQuery({
    queryKey: ["teacherQuizModules"],
    queryFn: getTeacherQuizModules,
  });

  return { isLoading, error, data, teacherQuizModuleIds: Object.keys(data || {}) };
}
